/**
 * API de identidade visual do sistema (separada da landing page).
 */
import axios from '@/api/config/axios';

const ME_BRANDING = '/api/v1/me/branding';

/**
 * @param {{ turmaId?: string|null, professorId?: string|null, signal?: AbortSignal }} [options]
 */
export async function fetchMyBranding(options = {}) {
    const params = {};
    if (options.turmaId) params.turma_id = options.turmaId;
    if (options.professorId) params.professor_id = options.professorId;

    const { data } = await axios.get(ME_BRANDING, {
        params,
        signal: options.signal,
    });
    return data?.data ?? null;
}

/**
 * Branding público do portal do professor (pré-login).
 * @param {string} slug
 * @param {{ signal?: AbortSignal }} [options]
 */
export async function fetchPortalBranding(slug, options = {}) {
    const { data } = await axios.get(`/api/v1/branding/portal/${encodeURIComponent(slug)}`, {
        signal: options.signal,
    });
    return data?.data ?? null;
}

/**
 * @param {{
 *   display_name?: string|null,
 *   logo_url?: string|null,
 *   auth_cover_image_url?: string|null,
 *   primary_color?: string|null,
 *   accent_color?: string|null,
 *   portal_slug?: string|null,
 *   portal_enabled?: boolean,
 * }} payload
 * @param {{ signal?: AbortSignal }} [options]
 */
export async function updateMyBranding(payload, options = {}) {
    const { data } = await axios.put(ME_BRANDING, payload, { signal: options.signal });
    return data?.data ?? null;
}

/**
 * Restaura identidade visual ao padrão da plataforma (limpa marca e desliga o portal).
 * @param {{ signal?: AbortSignal }} [options]
 */
export async function resetMyBranding(options = {}) {
    const { data } = await axios.post(`${ME_BRANDING}/reset`, null, { signal: options.signal });
    return data?.data ?? null;
}

/**
 * @param {{ file: File, onProgress?: (pct: number) => void, signal?: AbortSignal }} params
 */
export async function uploadMyBrandingLogo(params) {
    const { file, onProgress, signal } = params;
    const formData = new FormData();
    formData.append('file', file, file.name);

    const { data } = await axios.post(`${ME_BRANDING}/logo`, formData, {
        signal,
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (evt) => {
            if (onProgress && evt.total) {
                onProgress(Math.round((evt.loaded * 100) / evt.total));
            }
        },
    });
    return data?.data ?? data ?? null;
}

/**
 * Capa do login/cadastro (painel l-image).
 * @param {{ file: File, onProgress?: (pct: number) => void, signal?: AbortSignal }} params
 */
export async function uploadMyBrandingAuthCover(params) {
    const { file, onProgress, signal } = params;
    const formData = new FormData();
    formData.append('file', file, file.name);

    const { data } = await axios.post(`${ME_BRANDING}/auth-cover`, formData, {
        signal,
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (evt) => {
            if (onProgress && evt.total) {
                onProgress(Math.round((evt.loaded * 100) / evt.total));
            }
        },
    });
    return data?.data ?? data ?? null;
}
